import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_GRUPO_TEMA, API_EXCLUIR_GRUPO_TEMA, API_CRIAR_GRUPO_TEMA } from 'store/modules/api/grupoTema.actions'
import { filter } from 'lodash'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_GRUPO_TEMA.success: return payload
    case API_CRIAR_GRUPO_TEMA.success: return payload
    case API_EXCLUIR_GRUPO_TEMA.success: return filter(state, (o) => o.id !== payload)
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_GRUPO_TEMA)

const isSaving = loadingReducer(false, API_CRIAR_GRUPO_TEMA)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
})
